<template>
    <div ref="categoriesList" class="flex w-full flex-col gap-8">
        <template v-for="(category, index) in shop().filteredCategories" :key="category.id">
            <!-- eslint-disable-next-line tailwindcss/no-custom-classname -->
            <div :id="`category-${index}`" class="shop-category">
                <Category v-bind="category" />
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup async>
    import type { Ref } from 'vue'
    import { findHashElPosition } from '~/app/router.options'
    import Category from '~/components/Category/Category.vue'
    import { shop } from '~/store/shop'
    const { $event } = useNuxtApp()
    const categoriesList: Ref<Element | null> = ref(null)
    let observer: IntersectionObserver | null = null
    const { $listen, $destroy } = useNuxtApp()
    onBeforeUnmount(() => {
        $destroy('mounted-swiper')
        $destroy('search-focus-in')
        $destroy('search-focus-out')
        destroySwiperIntegration()
    })
    onMounted(() => {
        $listen('mounted-swiper', async () => {
            const route = useRoute()
            const currentScrollTop = document.documentElement.scrollTop || document.body.scrollTop
            if (route.hash) {
                const hashPosition = await findHashElPosition(route.hash, route.path)
                window.scrollTo(hashPosition)
                initSwiperIntegration()
            } else {
                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
            }
            if (currentScrollTop > 0) {
                window.addEventListener('scrollend', initSwiperIntegration, { passive: true })
            } else {
                initSwiperIntegration()
            }
        })
        $listen('search-focus-in', () => {
            destroySwiperIntegration()
        })
        $listen('search-focus-out', () => {
            initSwiperIntegration()
        })
    })
    function initSwiperIntegration () {
        if (categoriesList.value && categoriesList.value instanceof Element) {
            const swiperCategories = categoriesList.value.querySelectorAll('.shop-category')
            if (swiperCategories && swiperCategories.length) {
                const observerOptions = {
                    root: null,
                    rootMargin: '-50% 0% -50% 0%',
                    threshold: 0
                }
                observer = new IntersectionObserver(observerCallback, observerOptions as IntersectionObserverInit)
                swiperCategories.forEach(e => {
                    if (e instanceof Element && observer) {
                        observer.observe(e)
                    }
                })
                let position = null
                const checkIfScrollIsStatic = window.setInterval(() => {
                    if (position === window.scrollY) {
                        window.clearInterval(checkIfScrollIsStatic)
                    }
                    position = window.scrollY
                }, 50)
                window.addEventListener('scroll', endScroll, { passive: true })
            }
        }
        endScroll()
        window.removeEventListener('scrollend', initSwiperIntegration)
    }
    function observerCallback (entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            if (entry && entry.isIntersecting) {
                $event('category-list-in-viewport', {
                    id: entry.target.id
                })
            }
        })
    }
    function endScroll () {
        $event('category-list-end-scroll')
    }
    function destroySwiperIntegration () {
        if (observer) {
            observer.disconnect()
            observer = null
        }
        window.removeEventListener('scroll', endScroll)
    }
</script>
